import { useMemo } from 'react';
import { useCampaigns, useHasMany } from '../../store/campaignsStore';
import type { CampaignTypes, CampaignSource } from '../../types/campaign.types';
import { PRIZE_POP_CAMPAIGN_TYPE } from '../../types/campaign.types';

import { useCampaignsQuery } from './useCampaignsQuery';
import { useHasPrizePopSection } from 'store/app/appStore';

interface ItemsByCampaignTypeResult {
  items: CampaignSource[];
  hasMany: boolean;
  hasItems: boolean;
}

export const useItemsByCampaignType = (campaignType: CampaignTypes): ItemsByCampaignTypeResult => {
  const items = useCampaigns(campaignType);
  const hasMany = useHasMany(campaignType);
  const hasPrizePopSection = useHasPrizePopSection();

  // Ensures query is active (store update handled inside useCampaignsQuery)
   useCampaignsQuery(campaignType, { enabled: campaignType === PRIZE_POP_CAMPAIGN_TYPE ? hasPrizePopSection : true });

  return useMemo(() => ({
    items,
    hasMany,
    hasItems: items.length > 0,
  }), [items, hasMany]);
};
